// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"mD","contentFrame":"mE","button":"mF","header":"mG","text":"mH","contentImage":"mI"};